import { LitElement, PropertyValues } from "lit";
import { property} from "lit/decorators.js";
import { Constructor } from "src/lit/Constructor";
import { isHashChangeOnly } from "src/modules/helpers/navigation-helper";

export const HashLinkMixin = <T extends Constructor<LitElement>>(base: T) => {
  class HashLinkMixinClass extends base {    
     @property({type: String}) hash?: string;

    clickHandler = (e: Event) => {
      if (e.target instanceof HTMLAnchorElement && isHashChangeOnly(e.target)) {
        this.#tryScrollToHash(e.target.hash, "smooth")
      }
    }

    connectedCallback() {
      super.connectedCallback();
      if(this.shadowRoot != null) {
        this.shadowRoot.addEventListener('click', this.clickHandler);
      }
    }

    protected firstUpdated(_changedProperties: PropertyValues): void {
      super.firstUpdated(_changedProperties);

      let bestHash: string|null = null;
      if(window.location.hash.length >= 2){
        bestHash = window.location.hash;
      }
      if(this.hash) {
        bestHash = this.hash;
      }

      if(bestHash){
        this.#tryScrollToHash(bestHash, "auto")
      }
    }

    disconnectedCallback(): void {
      if(this.shadowRoot != null){
        this.shadowRoot.removeEventListener('click', this.clickHandler);
      } 
      super.disconnectedCallback();
    }

    updated(changedProperties: Map<string, any>) {
      if (changedProperties.has('hash')) {
          if(this.hash){
            this.#tryScrollToHash(this.hash, "auto")
          } else  {
            // todo we may want to scroll back to top if hash is removed?
          }
    }
  }

    #tryScrollToHash(hash:string, scrollBehavior:ScrollBehavior):void
    {
        var targetElement = (this.shadowRoot ?? this).querySelector(hash)
        if (targetElement) {
          requestAnimationFrame(() => {
            targetElement?.scrollIntoView({ "behavior": scrollBehavior, "block": "start" });
          });
        }
    }
  }
    return HashLinkMixinClass;
};